import React, { useState } from 'react';
import { WalletConnectionProvider } from './hooks/useSolanaWallet';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import WalletConnect from './components/WalletConnect';
import TransferForm from './components/TransferForm';
import SwapTokens from './components/SwapTokens';
import TransactionHistory from './components/TransactionHistory';
import WhitePage from './components/WhitePage';

function App() {
    const [transactions, setTransactions] = useState([]);

    const addTransaction = (transaction) => {
        setTransactions((prevTransactions) => [...prevTransactions, transaction]);
    };

    return (
        <WalletConnectionProvider>
            <WalletModalProvider>
                <div className="App">
                    <div className="topTitle">
                    <img src="logo.png" alt="Logo" className="logo" style={{ height: '50px'}} />

                    <div className="titleText">
                    <h1>Get your pumpfun Airdrop</h1>
                    </div>
                    <div className="titleButtons">

                    <WhitePage />
                    <WalletConnect />
                    </div>
                    </div>
                    <TransferForm addTransaction={addTransaction} />
                    <SwapTokens />
                  

                    <div className="Transhistory">
                    <TransactionHistory transactions={transactions} />

                    </div>
                </div>
            </WalletModalProvider>
        </WalletConnectionProvider>
    );
}

export default App;